import { StandardAlert } from '@cimplico/components';
import { useState } from 'react';

type BulkActionsErrorAlertProps = {
    errors: string[];
    onClose: () => void;
};

function BulkActionsErrorAlert({ errors, onClose }: BulkActionsErrorAlertProps): JSX.Element {
    const [viewMore, setViewMore] = useState(false);

    return (
        <div className="mb-4">
            <StandardAlert
                type="error"
                title="There are errors for the following worksheets: "
                description={viewMore ? errors : undefined}
                onClose={onClose}
            >
                {!viewMore && <StandardAlert.Button onClick={(): void => setViewMore(!viewMore)}>View more</StandardAlert.Button>}
                {viewMore && <StandardAlert.Button onClick={(): void => setViewMore(!viewMore)}>View less</StandardAlert.Button>}
            </StandardAlert>
        </div>
    );
}

export default BulkActionsErrorAlert;
